import React, { useContext } from "react"

import { LoggedOut, LoginButton } from "~components/Markdown"
import MicrocopyContext from "~contexts/MicrocopyContext"

import * as style from "./style.module.scss"

const LoggedOutPanel = () => {
  const microcopy = useContext(MicrocopyContext)
  return (
    <LoggedOut>
      <p>{microcopy.text("app_button.logged_out.description")}</p>

      <div className={style.buttons}>
        <LoginButton useCreateAppScope noWrap />
      </div>
    </LoggedOut>
  )
}

export default LoggedOutPanel
